import { Injectable } from '@angular/core';
import { TranslateService } from '../../../api/translate.service';

import { 
  fieldAddressLine1Col, 
  fieldAmountCol, 
  fieldCustomerNameCol, 
  fieldDateCol, 
  fieldIdCol, 
  fieldInvestmentProfileCol, 
  fieldInvoiceIdCol, 
  fieldIpMetroCol, 
  fieldLandAreaMeasureCol, 
  fieldLandCol, 
  fieldOpportunityCol,
  fieldPrimaryEmployeeFunctionalUnitCol, 
  fieldPrimaryEmployeeFunctionalUnitIdCol, 
  fieldPrimaryEmployeeIdCol, 
  fieldPrimaryEmployeeManagingOfficeCol, 
  fieldPrimaryEmployeeManagingOfficeIdCol, 
  fieldPrimaryEmployeeNameCol, 
  fieldPropertyAreaCol, 
  fieldPropertyBaseIdCol, 
  fieldPropertySubtypeCol, 
  fieldPropertyTypeCol, 
  fieldPropertyTypeSpaceLabelCol, 
  fieldSellerNameCol, 
  fieldSizeAreaMeasureCol, 
  fieldTransactionTypeCol,
  fieldTransSubtypeCol
} from '../../../utils/ag-grid/column-defs';
import { ColDef } from 'ag-grid-community';

@Injectable({
    providedIn: 'root'
  })
export class YTDSummaryCompanyIncomeReportService {

  constructor(private translateService: TranslateService) { }

  getHeaders(settings: { middle: any, left: any, right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_ID'),
        key: 'invoice_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoice_date',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_ID'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUST'),
        key: 'bill_to_customer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 30,
        style: { ...settings.middle },
      },
      // Deal Info Section
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_SUBTYPE'),
        key: 'transaction_subtype',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVESTMENT_PROFILE'),
        key: 'investment_profile',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_TYPE'),
        key: 'property_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_SUBTYPE'),
        key: 'property_subtype',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_TYPE_SPACE'),
        key: 'property_type_space',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_AREA'),
        key: 'property_area',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SIZE_AREA_MEASURE'),
        key: 'area_measure',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LAND'),
        key: 'land',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('LAND_AREA_MEASURE'),
        key: 'land_measure',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_AMOUNT'),
        key: 'lease_amount_or_sale_price',
        width: 30,
        style: { ...settings.middle }
      },
      // Producer Info Section
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
        key: 'primary_employee_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
        key: 'primary_employee_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
        key: 'primary_employee_functional_unit_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
        key: 'primary_employee_functional_unit_description',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
        key: 'primary_employee_managing_office_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
        key: 'primary_employee_managing_office_description',
        width: 30,
        style: { ...settings.middle },
      },
      // Fees Section
      {
        header: this.translateService.getTranslation('CBRE_FEE_$'),
        key: 'total_cbre_fee',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CBRE_FEE_FUMO'),
        key: 'total_cbre_revenue',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('SELLER_NAME'),
        key: 'seller_name', 
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_BASE_ID'),
        key: 'property_base_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('IP_METRO'), 
        key: 'ip_metro', 
        width: 30,
        style: { ...settings.middle }
      },
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      }, 
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_id',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
      },      
      {
        ...fieldDateCol,
        field: 'invoice_date',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
      },      
      {
        ...fieldOpportunityCol,
        minWidth: 250,
        headerName: this.translateService.getTranslation('OPPORTUNITY'),
      },    
      {
        ...fieldCustomerNameCol,
        field: 'bill_to_customer_name',
        minWidth: 250,
        headerName: this.translateService.getTranslation('BILL_TO_CUST'),
      }, 
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },     
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },         
      {
        ...fieldTransSubtypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_SUBTYPE'),
      },
      {
        ...fieldInvestmentProfileCol,
        field: 'investment_profile',
        headerName: this.translateService.getTranslation('INVESTMENT_PROFILE'),
      },
      {
        ...fieldPropertyTypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_TYPE'),
      },
      {
        ...fieldPropertySubtypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_SUBTYPE'),
      },
      {
        ...fieldPropertyTypeSpaceLabelCol,
        field: 'property_type_space',
        headerName: this.translateService.getTranslation('PROPERTY_TYPE_SPACE'),
      },
      {
        ...fieldPropertyAreaCol,
        headerName: this.translateService.getTranslation('PROPERTY_AREA'),
      },
      {
        ...fieldSizeAreaMeasureCol,
        field: 'area_measure',
        headerName: this.translateService.getTranslation('SIZE_MEASUREMENT'),
      },
      {
        ...fieldLandCol,
        headerName: this.translateService.getTranslation('LAND'),
      },
      {
        ...fieldLandAreaMeasureCol,
        field: 'land_measure',
        headerName: this.translateService.getTranslation('LAND_AREA_MEASURE'),
      },
      {
        ...fieldAmountCol,
        field: 'lease_amount_or_sale_price',
        headerName: this.translateService.getTranslation('TRANSACTION_AMOUNT'),
      },
      {
        ...fieldPrimaryEmployeeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
      },
      {
        ...fieldPrimaryEmployeeNameCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
      },      
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        field: 'primary_employee_functional_unit_description',
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeCol,
        field: 'primary_employee_managing_office_description',
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
      },
      {
        ...fieldAmountCol,
        field: 'total_cbre_fee',
        headerName: this.translateService.getTranslation('CBRE_FEE_$'),
      },
      {
        ...fieldAmountCol,
        field: 'total_cbre_revenue',
        headerName: this.translateService.getTranslation('CBRE_FEE_FUMO'),
        minWidth: 270,
      },      
      {
        ...fieldSellerNameCol,
        headerName: this.translateService.getTranslation('SELLER_NAME'),
      },
      {
        ...fieldPropertyBaseIdCol,
        headerName: this.translateService.getTranslation('PROPERTY_BASE_ID'),
      },
      {
        ...fieldIpMetroCol,
        headerName: this.translateService.getTranslation('IP_METRO'),
      },
    ];
  }
}